export const INVEST_FUND = "FUND@INVEST_FUND";
export const INVEST_FUND_INIT = "FUND@INVEST_FUND_INIT";
export const INVEST_FUND_SUCCESS = "FUND@INVEST_FUND_SUCESS";
export const INVEST_FUND_FAILED = "FUND@INVEST_FUND_FAILED";
